import { useState, useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import MemberList from 'components/Lists/MemberList'
import { ReactComponent as Loading } from 'icons/loading2.svg'

import {
  Container
} from './styles'

export default function PromoCodeMembersModal ({
  visible,
  promoCode,
  onClose: handleClose
}) {
  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [members, setMembers] = useState ([])
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getMembers (1)
  }, [promoCode])

  const getMembers = async (pageNumber = page) => {
    if (lastPage && pageNumber > lastPage) return

    try {
      if (pageNumber === 1) setLoading (true)

      const filters = `promo_code_id=${promoCode.id}&page=${pageNumber}&per_page=20`

      const { data: membersResponse } = await cutileiApi.get (`/members?${filters}`, requestConfig)
      const { data, meta } = membersResponse
      const membersData = pageNumber > 1 ? [...members, ...data] : data

      setMembers (membersData)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='lg' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Membros com o cupom {promoCode.code}</DialogTitle>
        </DialogHeader>
        {/* O id é o `scrollableTarget` da rolagem infinita da lista de membros */}
        <DialogBody id='promo-code-members'>
          <Container>
            {loading ? <Loading/> : (
              <MemberList
                members={members}
                totalMembers={total}
                hasMore={!(lastPage && page > lastPage)}
                onUpdate={member => setMembers (members.map (m => m.id === member.id ? member : m))}
                onScroll={getMembers}
                scrollableTarget='promo-code-members'
                style={{paddingTop: 3, paddingInline: 5}}
                endMessage={null}
              />
            )}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
